import { create } from 'zustand'

import { Setters, State } from './types'
import { initialState } from './state'

export const useZoneInformationStore = create<State & Setters>((set) => ({
  ...initialState,
  setIsLoading: (isLoading: boolean) => set(() => ({ isLoading })),
  setZone: (zone) => set(() => ({ zone })),
}))
